import React, { useEffect, useState } from "react";
import face3 from "../../assets/images/faces/22.jpg";
import "../../assets/css/styles.css";
import "../../assets/libs/bootstrap/css/bootstrap.min.css";
import noData from "../../assets/images/no-data.png";

const Favorite = ({ data }) => {
  const [languageData, setLanguageData] = useState(null);

  useEffect(() => {
    const defaultLang = process.env.REACT_APP_LANG;
    const cookieLang =
      localStorage.getItem("lang") ||
      document.cookie
        .split("; ")
        .find((row) => row.startsWith("lang="))
        ?.split("=")[1] ||
      defaultLang;

    if (cookieLang) {
      import(`../../lang/dashboard/${cookieLang}.json`)
        .then((data) => {
          setLanguageData(data);
        })
        .catch((error) => {
          console.error("Error loading language file:", error);
        });
    } else {
      console.warn("Language cookie 'lang' not found.");
    }
  }, []);

  if (!languageData) {
    return <div></div>;
  }

  return (
    <>
      <div className="col-xl-4 col-lg-6 col-sm-6 px-cd-3">
        <div className="card custom-card">
          <div className="card-body h-100" >
            <div className="flex-1">
              <div className="d-flex align-items-start justify-content-between">
                <span className="mb-0 flex-1 fs-14">
                  {languageData.indicators.favorite_expert}
                </span>
                <div className="ms-2">
                  <span className="avatar bg-danger-transparent text-danger">
                    <i className="bx bx-heart-circle fs-16"></i>
                  </span>
                </div>
              </div>
              {data.favorite_expert ? (
                <h3 className="mb-0 fs-18">
                  <div className="d-flex align-items-start">
                    <div className="avatar avatar-sm me-2">
                      <img
                        src={face3}
                        alt={data.favorite_expert}
                        className="rounded-1"
                      />
                    </div>
                    <a href="" data-interaction="expert_name">{data.favorite_expert}</a>
                  </div>
                </h3>
              ) : (
                <span class="mb-0 fs-18 font-15">⚊
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Favorite;
